import script from "./StudentInformationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentInformationModal.vue?vue&type=script&setup=true&lang=ts"

import "./StudentInformationModal.vue?vue&type=style&index=0&id=158295a0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-158295a0"]])

export default __exports__